export const runtimeConfig = {
  "id": "cmfxwywn80002z018st8gq7yw",
  "isActive": true,
  "isDefault": false,
  "isMultiCountry": false,
  "isSearchableByCountry": true,
  "isTelegramMiniApp": false,
  "isSubscriptionsEnabled": true,
  "isPhoneRequestOnStartEnabled": true,
  "isCountryAutoAssignmentEnabled": true,
  "isCountryAutoAssignmentIgnored": true,
  "isNoIndex": false,
  "isNoFollow": false,
  "isIndexNowEnabled": true,
  "indexNowKey": "a9e6766e0df544329365d8136428770b",
  "domain": "doskatv.co.il",
  "appLinksDomain": "a.doskatv.co.il",
  "iosBundleId": null,
  "androidPackageName": null,
  "alias": "DoskaTV",
  "name": {
    "en": "Объявления Израиля",
    "he": "Объявления Израиля",
    "ru": "DoskaTV"
  },
  "logoUrl": "https://doskatv-production-s3-data.s3.eu-central-1.amazonaws.com/2026/03/1773246443078-iiyo3stlpkyqmwr.png",
  "logoAlt": {
    "en": "Современная доска объявлений в Израиле - DoskaTV",
    "he": "Современная доска объявлений в Израиле - DoskaTV",
    "ru": "Современная доска объявлений в Израиле - DoskaTV"
  },
  "countryId": "cmcei05ek0001xr14f394k82t",
  "defaultLanguage": "ru",
  "languages": [
    "ru",
    "en",
    "he"
  ],
  "resultTranslatedLanguages": [],
  "defaultCurrency": "ILS",
  "authMethods": [
    "SMS",
    "EMAIL"
  ],
  "activeSitemapGenerationId": "cmw1ryykq0c6lxn1cppyudjw5",
  "createdAt": "2025-09-24T11:41:45.284Z",
  "updateAt": "2026-11-04T07:43:58.556Z",
  "defaultCountry": {
    "id": "cmcei05ek0001xr14f394k82t",
    "currency": "ILS",
    "countryCode": "IL",
    "hasActiveWhiteLabel": true,
    "name": {
      "ru": "Израиль",
      "uz": "Израиль",
      "en": "Israel",
      "he": "ישראל"
    },
    "normalizedName": "israel",
    "phoneCode": "+972",
    "phonePlaceholder": "00-000-0000",
    "inputMask": "055-123-4567",
    "allowedPhoneLengths": [
      9,
      10
    ],
    "authMethods": [
      "EMAIL",
      "SMS"
    ],
    "latitude": 32.0667,
    "longitude": 34.7667
  },
  "countriesWithWhiteLabels": [
    {
      "id": "cmcemnubo02x8xr14nltdiypi",
      "normalizedName": "germany",
      "whiteLabel": {
        "id": "cmkgvw82x0006yz019q2v616d",
        "isActive": true,
        "isDefault": false,
        "isMultiCountry": false,
        "isSearchableByCountry": true,
        "isTelegramMiniApp": false,
        "isSubscriptionsEnabled": false,
        "isPhoneRequestOnStartEnabled": true,
        "isCountryAutoAssignmentEnabled": true,
        "isCountryAutoAssignmentIgnored": true,
        "isNoIndex": false,
        "isNoFollow": false,
        "isIndexNowEnabled": false,
        "indexNowKey": "5da54e5ef1f54d80ac1dbf0ad2a155bb",
        "domain": "doskatv.de",
        "appLinksDomain": "a.doskatv.de",
        "iosBundleId": null,
        "androidPackageName": null,
        "alias": "DoskaTV",
        "name": {
          "en": "Объявления в Германии - doskatv.de",
          "he": "Объявления в Германии - doskatv.de",
          "ru": "Объявления в Германии - doskatv.de"
        },
        "logoUrl": "https://doskatv-production-s3-data.s3.eu-central-1.amazonaws.com/2026/03/1773241460463-ud2sbhjj1zwugqw.png",
        "logoAlt": {
          "en": "Современная доска объявлений в Германии - DoskaTV",
          "he": "Современная доска объявлений в Германии - DoskaTV",
          "ru": "Современная доска объявлений в Германии - DoskaTV"
        },
        "countryId": "cmcemnubo02x8xr14nltdiypi",
        "defaultLanguage": "ru",
        "languages": [
          "ru",
          "en"
        ],
        "resultTranslatedLanguages": [],
        "defaultCurrency": "EUR",
        "authMethods": [
          "SMS",
          "EMAIL"
        ],
        "activeSitemapGenerationId": "cmw1ts9hi0eg5xn1czvtuf1j5",
        "createdAt": "2026-01-16T12:58:07.210Z",
        "updateAt": "2026-11-04T07:59:07.159Z",
        "defaultCountry": {
          "id": "cmcemnubo02x8xr14nltdiypi",
          "currency": "EUR",
          "countryCode": "DE",
          "hasActiveWhiteLabel": true,
          "name": {
            "ru": "Германия",
            "uz": "Germany",
            "en": "Germany",
            "he": "גרמניה"
          },
          "normalizedName": "germany",
          "phoneCode": "+49",
          "phonePlaceholder": "00-000-000000",
          "inputMask": null,
          "allowedPhoneLengths": [
            11
          ],
          "authMethods": [
            "EMAIL",
            "SMS"
          ],
          "latitude": 0,
          "longitude": 0
        }
      }
    },
    {
      "id": "cmcei05ek0001xr14f394k82t",
      "normalizedName": "israel",
      "whiteLabel": {
        "id": "cmfxwywn80002z018st8gq7yw",
        "isActive": true,
        "isDefault": false,
        "isMultiCountry": false,
        "isSearchableByCountry": true,
        "isTelegramMiniApp": false,
        "isSubscriptionsEnabled": true,
        "isPhoneRequestOnStartEnabled": true,
        "isCountryAutoAssignmentEnabled": true,
        "isCountryAutoAssignmentIgnored": true,
        "isNoIndex": false,
        "isNoFollow": false,
        "isIndexNowEnabled": true,
        "indexNowKey": "a9e6766e0df544329365d8136428770b",
        "domain": "doskatv.co.il",
        "appLinksDomain": "a.doskatv.co.il",
        "iosBundleId": null,
        "androidPackageName": null,
        "alias": "DoskaTV",
        "name": {
          "en": "Объявления Израиля",
          "he": "Объявления Израиля",
          "ru": "DoskaTV"
        },
        "logoUrl": "https://doskatv-production-s3-data.s3.eu-central-1.amazonaws.com/2026/03/1773246443078-iiyo3stlpkyqmwr.png",
        "logoAlt": {
          "en": "Современная доска объявлений в Израиле - DoskaTV",
          "he": "Современная доска объявлений в Израиле - DoskaTV",
          "ru": "Современная доска объявлений в Израиле - DoskaTV"
        },
        "countryId": "cmcei05ek0001xr14f394k82t",
        "defaultLanguage": "ru",
        "languages": [
          "ru",
          "en",
          "he"
        ],
        "resultTranslatedLanguages": [],
        "defaultCurrency": "ILS",
        "authMethods": [
          "SMS",
          "EMAIL"
        ],
        "activeSitemapGenerationId": "cmw1ryykq0c6lxn1cppyudjw5",
        "createdAt": "2025-09-24T11:41:45.284Z",
        "updateAt": "2026-11-04T07:43:58.556Z",
        "defaultCountry": {
          "id": "cmcei05ek0001xr14f394k82t",
          "currency": "ILS",
          "countryCode": "IL",
          "hasActiveWhiteLabel": true,
          "name": {
            "ru": "Израиль",
            "uz": "Израиль",
            "en": "Israel",
            "he": "ישראל"
          },
          "normalizedName": "israel",
          "phoneCode": "+972",
          "phonePlaceholder": "00-000-0000",
          "inputMask": "055-123-4567",
          "allowedPhoneLengths": [
            9,
            10
          ],
          "authMethods": [
            "EMAIL",
            "SMS"
          ],
          "latitude": 32.0667,
          "longitude": 34.7667
        }
      }
    }
  ]
} as const;
